import React, { Component } from 'react';
import { Popover, Icon } from 'antd';
import { connect } from 'react-redux';
import IntlMessages from '../../components/utility/intlMessages';
import TopbarDropdownWrapper from './topbarDropdown.style';

class TopbarNotification extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
    };
  }
  hide() {
    this.setState({ visible: false });
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }
  handleClick = (object) => {
    if(this.props.handleClickNotification){
      this.setState({visible:false}, () => {
        this.props.handleClickNotification(object)
      })
    }
  }
  render() {
    const notifications = this.props.notifications || [];
    const content = (
      <TopbarDropdownWrapper className="topbarNotification">
        <div className="isoDropdownHeader">
          <h3>
            <IntlMessages id="sidebar.notification" />
          </h3>
        </div>
        <div className="isoDropdownBody">
          {notifications.map((notification, index) => (
            <div onClick={() => this.handleClick(notification)} className="isoNotificationListItem" key={`notif-${index}`}>
              <Icon type={'bell'}/>
              <div style={{width:'100%',marginLeft:10}}>
                <h5 style={{margin:0}}>{notification.asunto}</h5>
              </div>
            </div>
          ))}
          {
            !notifications || notifications.length === 0 ?
            <div style={{textAlign:'center', padding:10}}>
              <p style={{textAlign:'center', margin:0}}>No hay notificaciones</p>
            </div>
            :null
          }
        </div>
      </TopbarDropdownWrapper>
    );
    return (
      <Popover
        content={content}
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        placement="bottomLeft"
      >
        <div className="isoIconWrapper">
          <Icon type='bell'/>
          {
            notifications.length > 0?
              <span>{notifications.length}</span>
            :null
          }
        </div>
      </Popover>
    );
  }
}

export default connect(state => ({
  notifications: state.Telepase.notifications,
}))(TopbarNotification);
